/**
 * Scroll reveal animations using IntersectionObserver
 * Replaces scroll-event-based detection
 */

import { createObserver, prefersReducedMotion } from '../core/utils.js';

export class ScrollReveal {
  #observer;
  #elements = new Map();
  #staggerDelays = new WeakMap();

  constructor() {
    if (prefersReducedMotion()) {
      // Make all elements visible immediately
      document.querySelectorAll('.reveal, [data-reveal]').forEach(el => {
        el.classList.add('visible');
      });
      return;
    }

    this.#init();
  }

  #init() {
    // Create intersection observer
    this.#observer = createObserver(
      (entries) => this.#handleEntries(entries),
      { threshold: 0.15, rootMargin: '0px 0px -50px 0px' }
    );

    // Observe all reveal elements
    const elements = document.querySelectorAll('.reveal, [data-reveal]');
    elements.forEach((el, index) => {
      // Store stagger delay
      if (el.classList.contains('reveal-delay-1')) this.#staggerDelays.set(el, 100);
      else if (el.classList.contains('reveal-delay-2')) this.#staggerDelays.set(el, 200);
      else if (el.classList.contains('reveal-delay-3')) this.#staggerDelays.set(el, 300);
      else if (el.classList.contains('reveal-delay-4')) this.#staggerDelays.set(el, 400);
      
      this.#observer.observe(el);
    });

    // Navigation links reveal
    const navLinks = document.querySelectorAll('.nav-links a');
    setTimeout(() => {
      navLinks.forEach(link => link.classList.add('visible'));
    }, 100);
  }

  #handleEntries(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const el = entry.target;
        const delay = this.#staggerDelays.get(el) || 0;

        setTimeout(() => {
          el.classList.add('visible');
        }, delay);

        // Stop observing once revealed
        this.#observer.unobserve(el);
      }
    });
  }

  destroy() {
    this.#observer?.disconnect();
  }
}
